




















import { Component, Vue } from 'vue-property-decorator'
import avatar from '@/components/avatar/index.vue'
import { getUserInfo } from '@/apis/user'
import { afterLogout } from '../../utils/common'
@Component({
  name: 'userMsg',
  components: {
    avatar
  }
})
export default class extends Vue {
  private form = {
    departmentName: '',
    name: '',
    mobilePhone: '',
    id: 0,
    headPic: '',
    email: '',
    superiorName: ''
  }
  private get user () {
    return this.$store.state.user.user
  }
  private get circleUrl () {
    return this.$store.state.user.user.headPic || ''
  }
  private loginOut () {
    window.localStorage.removeItem('companyId')
    window.localStorage.removeItem('userId')
    afterLogout()
  }
  // 初始化数据
  private async fetchData () {
    let res = await getUserInfo()
    if (res.code === 200) {
      let obj = {
        id: res.data.id,
        name: res.data.name || '',
        headPic: res.data.headPic || '',
        email: res.data.email || '',
        departmentName: res.data.departmentName || '',
        superiorName: res.data.superiorName || '',
        mobilePhone: res.data.mobilePhone || ''
      }
      this.form = obj
    }

  }
  private mounted () {
    this.fetchData()
  }
}
